import React, {useEffect, useState, useRef, act } from 'react';
import ReactPlayer from 'react-player/lazy'
import { useDispatch, useSelector } from 'react-redux'
import { getAnalyzeInfo } from '../../actions/AnalyzeActions'
import PlayerOverlay from './PlayerOverlay';
import useWindowDimentions from '../hooks/useWindowDimentions'
import { formatSeconds } from '../../utils/formatTime'
import { findBestMatch } from '../../utils/bestMatch';

const CustomPlayer = (props) => {

    const dispatch = useDispatch()

    let time = 0

    const { playlistVideos } = useSelector(state => state.userPlaylists)
    const playerContainerRef = useRef()
    const [playerReady, setPlayerReady] = useState(false);
    const [videoUrl, setVideoUrl] = useState()
    const [menuVisible, setMenuVisible] = useState(true)
    const [mouse, setMouse] = useState(false)
    const [sound, setSound] = useState(0.5)
    const [muted, setMuted] = useState(false)
    const [timeDisplay, setTimeDisplay] = useState("00:00")
    const [videoProgress, setVideoProgress] = useState(0)
    const [soundProgress, setSoundProgress] = useState(50)
    const [quality, setQuality] = useState()
    const [activeTrack, setActiveTrack] = useState()
    const [isSeeking, setIsSeeking] = useState(false);

    const tracksRef = useRef(null)
    const { width, height } = useWindowDimentions()
    const isMobile = width < 992
    const [containerWidth, setContainerWidth] = useState(0)

    useEffect(() => {
        const parent = playerContainerRef.current?.parentElement
        if (!parent) return

        const updateWidth = () => setContainerWidth(parent.clientWidth)
        updateWidth()

        const observer = new ResizeObserver(updateWidth)
        observer.observe(parent)
        return () => observer.disconnect()
    }, [])

    const maxPlayerHeight = height * 0.82
    const naturalVideoWidth = maxPlayerHeight * 16 / 9

    // Outer box: on mobile it's the video's own box; on desktop it spans the
    // full available width (so PlayerOverlay, which fills it, reaches edge to edge)
    // while staying capped to maxPlayerHeight so the video is always fully visible.
    const playerWidth = containerWidth
        ? (isMobile ? Math.min(containerWidth, naturalVideoWidth) : containerWidth)
        : 0
    const playerHeight = containerWidth
        ? (isMobile ? playerWidth * 9 / 16 : maxPlayerHeight)
        : 0

    // The video itself never exceeds its natural 16:9 size for the capped height,
    // and is centered within the (possibly wider) outer box on desktop.
    const videoWidth = containerWidth
        ? (isMobile ? playerWidth : Math.min(naturalVideoWidth, containerWidth))
        : 0

    const onVideoChange = (e) => {
        setVideoProgress(e.target.value)
        let val = props.video.duration*e.target.value/100
        props.playerRef && props.playerRef.current.player.seekTo(val)
        let t = props.playerRef.current?.getCurrentTime()
        t && setTimeDisplay(formatSeconds(t))
        if(props.video && props.video.tracks && props.video.tracks.length > 1){
            let currentTrackIndex = props.video.tracks.findIndex(track=>track.starts_at<=t && track.ends_at>=t)
            setActiveTrack(props.video.tracks[currentTrackIndex])
        }
    }



    const onSoundChange = (e) => {
        setSound(e.target.value/100)
        setSoundProgress(e.target.value)
        setMuted(false)
    }

    useEffect(() => {
        if (!props.video?.scripted_bunny_path) return;

        setPlayerReady(false);   // 🔁 force new ready cycle
        setVideoUrl(props.video.scripted_bunny_path);
        setTimeDisplay("00:00");

    }, [props.video?.scripted_bunny_path]);


    useEffect(() => {
        if (!props.video) return;
        if (!playerReady) return;
        if (!props.playerRef?.current) return;
        if (!props.video.tracks?.length) return;

        let s = props.searchParams.get('s');

        let targetTrack = null;

        if (s === '1') {
            let list = props.filterList
                .filter(item => item[2] === 2 || item[2] === 3)
                .map(item => item[0]);

            targetTrack = findBestMatch(list, props.video.tracks, 'member_ids');
        }

        if (!targetTrack) {
            targetTrack = props.video.tracks[0];
        }

        if (!targetTrack) return;

        setIsSeeking(true);

        props.playerRef.current.seekTo(targetTrack.starts_at, "seconds");

        setActiveTrack(targetTrack);
        setVideoProgress((targetTrack.starts_at * 100) / props.video.duration);

        props.setSearchParams({ ...Object.fromEntries([...props.searchParams]), s: 0 });

        // unlock progress after seek settles
        setTimeout(() => setIsSeeking(false), 400);

    }, [playerReady]);


    useEffect(()=>{
        if(!mouse){
            const identifier = setTimeout(() => {
                setMenuVisible(false)
            }, 1000);

            return () => {
                clearTimeout(identifier)
            }
        } else {
            setMenuVisible(true)
        }
    },[mouse])

    const endHandler = () => {
        if (playlistVideos && playlistVideos.length){
          let index = playlistVideos.findIndex(data => data.id === props.video.id);
          if(index < playlistVideos.length-1){
            props.setSearchParams({ ...Object.fromEntries([...props.searchParams]), v:playlistVideos[index+1].id})
            localStorage.setItem('video_id', playlistVideos[index+1].id)
          }
        }
        props.setPlaying(true)
    }

    const prevHandler = () => {
        if (playlistVideos && playlistVideos.length){
            let index = playlistVideos.findIndex(data => data.id === props.video.id);
            if(index > 0){
              props.setSearchParams({ ...Object.fromEntries([...props.searchParams]), v:playlistVideos[index-1].id})
              localStorage.setItem('video_id', playlistVideos[index-1].id)
            }
          }
        props.setPlaying(true)
    }

    const startHandler = () => {
        setTimeout(()=>{
          if(props.playerRef && props.playerRef.current && props.video) {
            let current_time = Math.round(props.playerRef.current.getCurrentTime())
            if(props.video){
              if (props.video.duration-30<current_time){
                  time = Math.floor((props.video.duration-30)/5)*5
              } else {
                  time = Math.floor(current_time/5)*5
              }
              dispatch(getAnalyzeInfo(props.video.id, current_time, time))
            }
          }
        }, 4500)
      }

    const mouseMove = (e) => {
        setMenuVisible(true)
        setMouse(true)
        setTimeout(() => {
            setMouse(false);
        }, 500)
    }

    const handleProgress = (state) => {
        if (!props.video) return;
        if (!activeTrack) return;
        if (isSeeking) return;

        let t = props.playerRef.current?.getCurrentTime();
        if (t) setTimeDisplay(formatSeconds(t));

        let percent = (state.playedSeconds / props.video.duration) * 100;
        setVideoProgress(percent);

        if (activeTrack.ends_at < state.playedSeconds) {
            const idx = props.video.tracks.findIndex(t => t.id === activeTrack.id);
            setActiveTrack(props.video.tracks[idx + 1]);
        }
    };


    useEffect(()=>{

        if (!playerReady) return;

        if(!activeTrack) return;
        if(!props.video || !props.video.tracks) return;
        if(!tracksRef || !tracksRef.current) return;

        const index = props.video.tracks.findIndex(t=>t.position===activeTrack.position)
        if((props.video.tracks.length - index)*293 > width){
            tracksRef?.current?.slickGoTo(index)
        } else {
            let ind = props.video.tracks.length - Math.floor(width/293)
            tracksRef?.current?.slickGoTo(ind)
        }
    }, [activeTrack, tracksRef, playerReady])



    const readyHandler = () => {

        setPlayerReady(true);
        if(videoUrl && props.playerRef && props.playerRef.current){
            const internalPlayer = props.playerRef.current?.getInternalPlayer('hls')
            const levels = internalPlayer?.levels
            if(internalPlayer?.currentLevel && internalPlayer.currentLevel === -1){
                internalPlayer.currentLevel = 0
                let currentQuality = levels[0]
                setQuality(currentQuality.height)
            }
        }
    }


    const trackClickHandler = (e,track) => {
        e.stopPropagation()
        let trackStart = track.starts_at*100/props.video.duration
        setVideoProgress(trackStart)
        setActiveTrack(track)
        props.playerRef && props.playerRef.current.player.seekTo(track.starts_at)
        setTimeDisplay(formatSeconds(track.starts_at))
      }


    return (
        <>
            <div className = 'position-relative'
                ref = {playerContainerRef}
                onMouseMoveCapture={mouseMove}
                onMouseLeave={()=>setMenuVisible(false)}
                onTouchStart={mouseMove}
                style={
                    playerWidth ? {
                        width: `${playerWidth}px`,
                        height: `${playerHeight}px`,
                        margin: "0 auto",
                        overflow: "hidden",
                    } : {
                        aspectRatio: "16/9",
                        width: "100%",
                        maxHeight: "82vh",
                        overflow: "hidden",
                    }
                }
            >
                <div className='position-absolute h-100'
                    style={
                        videoWidth ? {
                            width: `${videoWidth}px`,
                            left: "50%",
                            transform: "translateX(-50%)",
                        } : { width: "100%" }
                    }
                >
                    <ReactPlayer
                        ref = {props.playerRef}
                        className='react-player'
                        // controls
                        url = {videoUrl}
                        onEnded = {endHandler}
                        onStart={()=>startHandler()}
                        onReady={()=>readyHandler()}
                        // onPlay={()=>setPlaying(true)}
                        onPause={()=>props.setPlaying(false)}
                        onProgress = {handleProgress}
                        playing = {props.playing}
                        volume = {sound}
                        muted = {muted}
                        // light = {`https://img.cugate.com/?o=CUTV_VIDEO&i=${props.video.id}&s=600`}
                        config={{
                        file: {
                            attributes: {
                            controlsList: 'nodownload noprops.fullscreen'
                            }
                        }
                        }}
                        width="100%"
                        height='100%'
                    />
                </div>

                {/* custom controls and player features */}
                <PlayerOverlay
                    playing = {props.playing}
                    setPlaying = {props.setPlaying}
                    endHandler = {endHandler}
                    prevHandler = {prevHandler}
                    video = {props.video}
                    menuVisible = {menuVisible}
                    setMenuVisible = {setMenuVisible}
                    playlistVideos = {playlistVideos}
                    playerRef = {props.playerRef}
                    playerContainerRef = {playerContainerRef}
                    videoProgress = {videoProgress}
                    onVideoChange = {onVideoChange}
                    onSoundChange = {onSoundChange}
                    soundProgress = {soundProgress}
                    timeDisplay = {timeDisplay}
                    videoUrl = {videoUrl}
                    quality = {quality}
                    setQuality = {setQuality}
                    searchParams = {props.searchParams}
                    setSearchParams = {props.setSearchParams}
                    muted = {muted}
                    setMuted = {setMuted}
                    handleRewind = {props.handleRewind}
                    analyzeRef = {props.analyzeRef}
                    activeTrack = {activeTrack}
                    trackClickHandler = {trackClickHandler}
                    tracksRef = {tracksRef}
                    videoClickHandler = {props.videoClickHandler}
                />
            </div>
        </>
    );
};

export default CustomPlayer;